import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthServiceProxy, RefreshTokenRequest } from '../../../shared/service-proxies/event-service-proxy';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private refreshToken : string = '';
  private companyId: string|null = null;
  private lastTokenRefresh: number | null = null; // Variable to track the last token refresh time
  private tokenRefreshInterval = 15 * 60 * 1000; // 15 minutes in milliseconds

  constructor(private jwtHelper: JwtHelperService, private authService: AuthServiceProxy) {}
  /**
   * Возвращает ID компании пользователя
   * @returns 
   */
  getCompanyId() : string {
   if (this.companyId) return this.companyId;
    const accessToken = this.getAccessToken();
    if (!accessToken) return null;
    const decodedToken = this.jwtHelper.decodeToken(accessToken);
    this.companyId = decodedToken.companyId;
    return this.companyId;
  }
  setRefreshToken(token: string) {
    this.refreshToken = token;
    this.startProlongSession();
  }

  startProlongSession() {
    setInterval(() => {
      const now = Date.now();

      // If the last token refresh was more than 15 minutes ago, refresh the token
      if (!this.lastTokenRefresh || (now - this.lastTokenRefresh) >= this.tokenRefreshInterval) {
        this.refreshTokenIfNeeded();
      }
    }, this.tokenRefreshInterval);
  }

  getAccessToken(): string | null {
    // Assuming you store the token elsewhere, e.g., a variable, in-memory, or some other secure store
    // Replace this with your actual implementation for fetching the token
    if (localStorage != null && localStorage != undefined) return localStorage?.getItem("access_token")??null; // This is a placeholder. Replace it with the actual token retrieval logic
    return null;
  }

  isTokenExpired(token: string): boolean {
    return this.jwtHelper.isTokenExpired(token);
  }

  private refreshTokenIfNeeded() {
    const accessToken = this.getAccessToken();
    if (accessToken && this.isTokenExpired(accessToken)) {
      if (this.refreshToken) {
        // Call authService to refresh the token
        const body = new RefreshTokenRequest();
        body.refreshToken = this.refreshToken;
        this.authService.refreshToken(body).subscribe(
          (response: any) => {
            // Save the new access and refresh tokens (replace with actual storage logic)
            localStorage.setItem('access_token', response.accessToken);
            this.refreshToken = response.refreshToken;
            // Update the last token refresh time
            this.lastTokenRefresh = Date.now();
          },
          (error) => {
            console.error('Failed to refresh token:', error);
            // Optionally handle token refresh failure (e.g., log out the user)
          }
        );
      }
    }
  }
}
